import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common/utils/LocalisationUtils.js'

class MagstimTableOrganisation extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
				{ title: CurrentLang().organisation, property: 'Name', isSearchable:true },
				{ title: CurrentLang().number_of_users, property: 'SystemUserFraction', formatter: this.formatFraction },
				{ title: CurrentLang().patient_status, property: 'Status', alwaysSortedDirection: 1, formatter: this.formatStatus }
			],
			data: data
		};
	}


	resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Status', 'Active');
	}

}

export default MagstimTableOrganisation;